import * as actionTypes from "../constants";

// something selected on the dirty changes dialog: hide dialog and clear changes if necessary
export const hideUnsavedChangesWarningAction = (confirmed: boolean) => (dispatch) => {
  dispatch(hideDiscardDirtyAdvice(confirmed));
};

// show dirty changes dialog action
export const promptDiscardDirtyAdviceAction =
  (okCallback?: () => void, cancelCallback?: () => void) => (dispatch) => {
    dispatch(promptDiscardDirtyAdvice(okCallback, cancelCallback));
  };

// show dirty changes dialog: update reducers
const promptDiscardDirtyAdvice = (okCallback?: () => void, cancelCallback?: () => void) => ({
  payload: {
    cancelCallback,
    confirmed: false,
    okCallback,
    show: true,
  },
  type: actionTypes.PROMPT_DISCARD_DIRTY_ADVICE_UI,
});

// clear dirty changes dialog information in UI reducer and hide it
const hideDiscardDirtyAdvice = (confirmed: boolean) => ({
  payload: {
    confirmed,
    show: false,
  },
  type: actionTypes.HIDE_DISCARD_DIRTY_ADVICE_UI,
});
